import { render, staticRenderFns } from "./ChangeTicketsInterface.vue?vue&type=template&id=92743910&scoped=true"
import script from "./ChangeTicketsInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeTicketsInterface.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChangeTicketsInterface.vue?vue&type=style&index=0&id=92743910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92743910",
  null
  
)

export default component.exports